import type { IPagingFilter } from "@frui.ts/data";
import { Router } from "@frui.ts/screens";
import type { interfaces } from "inversify";
import RefundRepository from "repositories/refundRepository";
import EnumService from "services/enumService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import OptionsService from "services/optionsService";
import RefundsApprovalService from "services/refundsApprovalService";
import AppRouter from "services/router";
import SecurityService from "services/securityService";
import AlertsViewModel from "viewModels/alertsViewModel";
import CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundDetailViewModel from "../transferRefundDetailViewModel";
import type TransferPaymentType from "entities/transferPaymentType";
import PriceListService from "services/priceListService";

@Router.registerRoute({ name: Router.Self, route: ":refundId" })
export default class DomesticRefundDetailViewModel extends TransferRefundDetailViewModel {
  static Factory({ container }: interfaces.Context) {
    return (refundId: string, pagingFilter: IPagingFilter, transferType: TransferPaymentType) =>
      new DomesticRefundDetailViewModel(
        refundId,
        pagingFilter,
        transferType,
        container.get(LocalizationService),
        container.get(AppRouter),
        container.get(RefundsApprovalService),
        container.get(RefundRepository),
        container.get(OptionsService),
        container.get(SecurityService),
        container.get(EventBus),
        container.get(CountrySelectViewModel.Factory),
        container.get(EnumService),
        container.get(PriceListService),
        container.get(AlertsViewModel)
      );
  }
}
